export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./consent.vue?vue&type=template&id=4e3535dc&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/consent.vue?vue&type=template&id=4e3535dc&
// module id = 1632
// module chunks = 0